export const departmentsReducer = (state = {loading: false, resultdepartment: null, departments: [], department: null, total: 0} , action) => {
    switch (action.type) {
        case 'DEPARTMENT_GETALL_SUCCESS':
            return {
                ...state,
                loading: false,
                departments: action.payload.departments || [],
                total: action.payload.total || 0
            }
        case 'DEPARTMENT_GET_SUCCESS':
            return {
                ...state,
                loading: false,
                department: action.payload || null
            }
        case 'DEPARTMENT_ADD_SUCCESS':
            return {
                ...state,
                loading: false,
                resultdepartment: action.payload.message,
                department: action.payload.department,
                departments: [...state.departments, action.payload.department],
            }
        case 'DEPARTMENT_EDIT_SUCCESS':
            if(action.payload.department){
                return {
                    ...state,
                    loading: false,
                    resultdepartment: action.payload.message,
                    department: action.payload.department,
                    departments: state.departments.map(department => department._id === action.payload.department._id ? action.payload.department : department),
                }
            }else{
                return {
                    ...state,
                    loading: false,
                    resultdepartment: action.payload.message || action.payload
                }
            }
        case 'DEPARTMENT_RESET_RESULT':
            return {
                ...state,
                resultdepartment: null
            }
        case 'DEPARTMENT_LOADING':
            return {
                ...state,
                loading:true
            }
        case 'DEPARTMENT_NOT_LOADING':
            return {
                ...state,
                loading: false
            }
        case 'DEPARTMENT_ERROR':
            return {
                ...state,
                loading: false,
                resultdepartment: action.payload
            }
        default:
            return state
    }
}
